import React from 'react'
import { IconButton, IconButtonProps } from '@mui/material'

const IconButtonWrapper: React.FC<IconButtonProps> = ({ ...props }) => (
  <IconButton {...props} />
)

export default IconButtonWrapper
